import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export interface ChatNoticeState {
  messageKey: string
  tone: 'success' | 'error'
}

interface ChatNoticeProps {
  notice: ChatNoticeState | null
  onDismiss: () => void
}

/** Inline live-region feedback for chat mutations and transient failures. */
export function ChatNotice({ notice, onDismiss }: ChatNoticeProps) {
  const { t } = useTranslation()
  const dismissRef = useRef(onDismiss)

  useEffect(() => {
    dismissRef.current = onDismiss
  }, [onDismiss])

  useEffect(() => {
    if (!notice) return
    const timer = window.setTimeout(() => dismissRef.current(), 5000)
    return () => window.clearTimeout(timer)
  }, [notice])

  if (!notice) return null

  return (
    <div
      role={notice.tone === 'error' ? 'alert' : 'status'}
      aria-live={notice.tone === 'error' ? 'assertive' : 'polite'}
      className={`chat-notice ${notice.tone === 'error' ? 'chat-notice--error' : ''}`}
    >
      {t(notice.messageKey)}
    </div>
  )
}
